import 'components/shortlist/actions/save/index.css'
import '../contact-list-change/index.css'

import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'

import {
  listBusinessFormDone,
  listFormClose,
  listFormIncludeBusiness,
  listFormSave,
} from '@disco/state-management/actions/EmailGroupActions'
import {
  getContactBusinesses,
  getFormContacts,
} from '@disco/state-management/selectors/contacts'

import type { Business, Contact } from 'types/list'
import type { State } from 'types/redux'

import DocumentHeadTags from 'components/document-head-tags'
import Button from 'components/ui/button'
import Checkbox from 'components/ui/checkbox'
import Heading from 'components/ui/heading'
import UserAvatar from 'components/ui/user-avatar'
import modalStyles from 'components/utils/modalStyles'

function mapStateToProps(state: State) {
  return {
    contactBusinesses: getContactBusinesses(state),
    listForm: state.forms.listForm,
    contacts: getFormContacts(state),
  }
}

const mapDispatchToProps = {
  listFormIncludeBusiness,
  listBusinessFormDone,
  listFormSave,
  listFormClose,
}

class ContactBusinessSelect extends React.Component<{
  listForm: State['forms']['listForm']
  contactBusinesses: Array<any>
  contacts: Array<Contact>
  listFormIncludeBusiness: typeof listFormIncludeBusiness
  listFormSave: typeof listFormSave
  listBusinessFormDone: typeof listBusinessFormDone
  listFormClose: typeof listFormClose
}> {
  _isListItemSelected(item: any): 'none' | 'all' {
    return item.checked
  }

  _clickListItem = (
    contact: Contact,
    business: Business,
    currentVal: 'none' | 'all',
  ) => {
    if (currentVal === 'all') {
      this.props.listFormIncludeBusiness(contact, business, 'none')
    } else {
      this.props.listFormIncludeBusiness(contact, business, 'all')
    }
  }
  _onClose = () => {
    this.props.listFormClose()
  }
  _handleSubmit = () => {
    switch (this.props.listForm.mode) {
      case 'MULTIPLE_LISTS':
      case 'SINGLE_LIST':
        this.props.listBusinessFormDone()
        break

      case 'EXISTING_LIST':
        this.props.listFormSave()
        break
    }
  }

  _renderContact(contact: any) {
    return contact.businesses.map(business => {
      const checked = this._isListItemSelected(business)

      return (
        <div className="col-xs-6" key={business.id}>
          <Checkbox
            className="ContactsTable_Checkbox"
            checked={checked !== 'none'}
            // @ts-expect-error
            partial={checked === 'some'}
            onChange={() => this._clickListItem(contact, business, checked)}
          >
            {business.name}
          </Checkbox>
        </div>
      )
    })
  }

  render() {
    const saving = this.props.listForm.saving
    const title =
      this.props.listForm.keyStep === 'LIST_MODAL_4_MANAGE_LISTS'
        ? 'Manage mailing lists'
        : 'New Mailing List'
    return (
      <div>
        <DocumentHeadTags title={`${title} | DISCO`} />
        <Modal onRequestClose={this._onClose} isOpen style={modalStyles}>
          <Theme>
            <div className="Form Form_Channel">
              <Heading size="600">{title}</Heading>
              <div className="ContactListChange_Selected">
                The following users are members of multiple DISCO businesses.
                Choose which business you’d like to send to for these users:
              </div>
              <div className="ContactListChange_Header">
                <div className="row row-flexbox-defaults">
                  <div className="col-xs-4">Name</div>
                  <div className="col-xs-8">Business</div>
                </div>
              </div>
              <div>
                {this.props.contactBusinesses.map(cb => (
                  <div key={cb.id} className="ContactListChange_Groups">
                    <div className="row row-flexbox-defaults">
                      <div className="col-xs-4">
                        <div>
                          <UserAvatar
                            className="ContactListChange_Avatar"
                            name={cb.name}
                            size="1.25rem"
                            fontSize=".6rem"
                          />
                          {cb.name}
                        </div>
                      </div>
                      <div className="col-xs-8">
                        <div className="row row-flexbox-defaults">
                          {this._renderContact(cb)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {this.props.listForm.error ? (
                <div className="Login_ValidationMessage">
                  {this.props.listForm.error.toString()}
                </div>
              ) : null}
              <div className="Form_ButtonsContainer separated-small">
                <Button
                  caption="Save changes"
                  progressIndicator={saving}
                  progressCaption="Saving changes"
                  onClick={this._handleSubmit}
                  appearance="primary"
                />
                <Button caption="Cancel" onClick={this._onClose} />
              </div>
            </div>
          </Theme>
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactBusinessSelect) as any
